<template>
  <div v-cloak class="about">
    <van-search v-model="select_value" placeholder="请输入大神关键词搜索" :clearable="true" @search="do_search" @clear="do_clear"></van-search>
    <van-pull-refresh v-model="data_subscript.is_refresh" @refresh="onRefresh(true)" style="margin-bottom: 50px">
      <van-list class="list-wrap" v-model="data_subscript.is_loading"
                :finished="data_subscript.is_load_finished"
                :immediate-check="false"
                finished-text="没有更多了"
                :error.sync="data_subscript.is_error"
                error-text="请求失败，点击重新加载"
                @load="onLoad">
        <van-cell class="list-cell"  v-for="(item, index) in data_subscript.list" :key="index" v-on:click="go_detail(item.writer_id)" >
          <van-row  type="flex" justify="start" align="ceter">
            <van-col span="4">
              <writer-avatar shape="circle" :size="48" :writer="item"></writer-avatar>
<!--              <div class="avatar-wrap"><van-image round scale-down lazy-load :src="item.avatar.web_path"></van-image></div>-->
            </van-col>
            <van-col span="15" >
              <div class="writer-wrap">
                <div class="writer-nickname">{{item.writer_name}}</div>
                <div class="writer-labels ">
                  <div  v-for="(item, index) in item.labels" :key="index" class="writer-label" :class="['label'+Math.floor(Math.random()*3)]">{{item.text}}</div>
                </div>
              </div>
            </van-col>
            <van-col span="5">
              <div class="writer-wrap right">
                <van-button class="subscripted" hairline  color="#888"  plain round type="info" size="small" @click.stop="unsubscript(tabName.all, item.writer_id, index)">
                  取关
                </van-button>
              </div>
            </van-col>
          </van-row>
        </van-cell>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
    import WriterAvatar from "@/views/components/WriterAvatar";
    export default {
        name: 'subscript',
      components:{
        WriterAvatar
      },
        data() {
            return {
                tabName:{
                  all:'all',
                  subscript:'subscript'
                },
                select_value:'',
                data_subscript:{
                    page: 0,
                    list: [],
                    is_error: false,
                    is_refresh: false,
                    is_loading: false,
                    is_load_finished: false
                }
            }
        },
        created: function () {
            let that = this;
            this.eventbus.$on(this.weconfig.event.subscriptChanged, function (event) {
                this.onRefresh(false)
            }.bind(this))
            this.data_subscript.page = 1;
            this.getDataSubscript(this.data_subscript.page, this.select_value,  false)
        },
        mounted:function(){

        },
        destroyed:function(){
          this.eventbus.$off(this.weconfig.event.subscriptChanged);
        },
        methods: {
            onRefresh(refresh) {
                if(refresh)this.select_value = '';
                this.data_subscript.page = 1;
                this.getDataSubscript(this.data_subscript.page, this.select_value,  refresh)
            },
            onLoad() {
              this.data_subscript.page++;
              this.getDataSubscript(this.data_subscript.page, this.select_value,  false)
            },
            getDataSubscript:function(page, select, refresh){
                let that = this;
                this.weapi.request({
                    url: 'writer_list',
                    method: 'get',
                    params: {page:page,type:this.tabName.subscript,select:select},
                }).then(res => {
                    if (res.data.code === '200') {
                        let _list = res.data.data.list;
                        if (refresh) {
                            that.$toast('刷新成功！');
                            that.data_subscript.is_refresh = false;
                        }
                        if (that.data_subscript.page <= 1) {
                            that.data_subscript.list = [];
                            that.data_subscript.is_load_finished = false;
                        }
                        for (let i = 0; i < _list.length; i++) {
                            that.data_subscript.list.push(_list[i]);
                        }
                        if (res.data.data.end) {
                            that.data_subscript.is_load_finished = true;
                        }
                    }
                    else {
                        that.data_subscript.is_refresh = false;
                        that.data_subscript.is_error = true;
                    }
                }).catch(function (error) {
                    that.$toast('系统错误，请稍后重试！');
                    that.data_subscript.is_refresh = false;
                    that.data_subscript.is_error = true;
                }).finally(function (response) {
                    that.data_subscript.is_loading = false;
                })
            },
            unsubscript:function(type, writer_id, index){
                if(!this.westore.getters.logined){
                    this.$router.push({ name:  this.werouter.login.name, query: { redirect_name:  this.werouter.author.name,} })
                    return;
                }
                let that = this;
                this.weapi.request({
                    url: 'writer_unsubscript',
                    method: 'post',
                    params: {writer_id:writer_id},
                }).then(res => {
                    if (res.data.code === '200') {
                      that.data_subscript.list.splice(index, 1, res.data.data);
                      that.data_subscript.page = 1;
                      that.getDataSubscript(that.data_subscript.page, that.select_value, false)
                    }
                    else {
                        that.$toast(res.data.message);
                    }
                }).catch(function (error) {
                    that.$toast('系统错误，请稍后重试！');
                }).finally(function (response) {
                })
            },
            do_search:function(value){
                this.onRefresh(false);
                this.onRefresh(false);
            },
            do_clear:function(res){
                // this.do_search();
            },
            go_detail: function (ID) {
                if(!this.westore.getters.logined){
                  this.$router.push({
                    name: this.werouter.login.name,
                    query: {redirect_name:this.werouter.author.name}
                  }).catch(function () {})
                  return
                }
                this.$router.push({ name: this.werouter.authordetail.name, params: { writer_id: ID } })
            }
        }
    }
</script>
<style>
  .writer-wrap{
    height: 100%;
    padding: 0 10px 0 0;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: flex-start;
  }
  .writer-wrap.right{
    padding: 0;
    align-items: flex-end;
    margin-right: 1px;
  }
  .writer-labels{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;

  }
  .writer-nickname{
    font-weight: 600;
  }
  .writer-labels .writer-label{
    font-size: 12px;
    padding: 0 5px;
    border-radius: 0 32px 32px 32px;
    line-height: 18px;
    margin-top: 5px;
    margin-right:10px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    max-width: calc(14px * 6);
  }
  .writer-label.label0{
    border: 1px solid #ee0a24;
    color: #ee0a24;
  }
  .writer-label.label1{
    border: 1px solid #1989fa;
    color: #1989fa;
  }
  .writer-label.label2{
    border: 1px solid #ed6a0c;
    color: #ed6a0c;
  }
  .subscripted{
    /*width:64px;*/
    height: 24px;
    padding: 0 8px;
    line-height: 24px;
  }
  .dissubscript{
    /*width:64px;*/
    height: 24px;
    padding: 0 8px;
    line-height: 24px;
  }
</style>
